import React, { Component } from 'react';
import { Handle, Position } from '@xyflow/react';

class CircleNode extends Component {
  handleDoubleClick = (event) => {
    console.log('CircleNode double clicked:', this.props);
    console.log('Event:', event);
    console.log('Event target:', event.target);
    console.log('Event currentTarget:', event.currentTarget);
    console.log('Data:', this.props.data);
    // Không gọi event.stopPropagation() để cho phép sự kiện lan lên ReactFlow
    // Không gọi event.preventDefault() để cho phép sự kiện mặc định
    // Không gọi onDoubleClick từ data để cho phép sự kiện lan lên ReactFlow
  };

  render() {
    const { positionAbsoluteX, positionAbsoluteY, id } = this.props;
    const label = `Position x:${Math.round(positionAbsoluteX)} y:${Math.round(positionAbsoluteY)}`;

    return (
      <div 
        data-id={id}
        onDoubleClick={this.handleDoubleClick}
        style={{ cursor: 'pointer' }}
      >
        <div>{label || 'no node connected'}</div>
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />
      </div>
    );
  }
}

export default CircleNode; 